import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { HomePage } from '../home/home';
import { LoginPage } from '../login/login';

@IonicPage()
@Component({
  selector: 'page-forgot-password',
  templateUrl: 'forgot-password.html',
})
export class ForgotPasswordPage {
  loginForm: FormGroup;
  submitAttempt: boolean = false;
  loading;

  constructor(public asf: AngularFirestore,  public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, public alertCtrl: AlertController, public loadingCtrl: LoadingController, public FireAuth: AngularFireAuth) {
    this.isLoggedIn();
    this.loginForm = formBuilder.group({
      email: ['', Validators.compose([Validators.maxLength(45), Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/), Validators.required])]//,
      // password: ['', Validators.compose([Validators.minLength(6)])]
    });
  }

  ionViewDidLoad() {
    ////console.log('ionViewDidLoad LoginPage');
  }

  login() {
    this.submitAttempt = true;
    if (!this.loginForm.valid) {
      ////console.log("Incorrecto")
    }
    else {
      this.presentLoading();
      this.FireAuth.auth.sendPasswordResetEmail(this.loginForm.value.email).then(()=>{
      //this.FireAuth.auth.signInWithEmailAndPassword(this.loginForm.value.email, this.loginForm.value.password).then((usuario) => {
        ////console.log("ResetPassword");
        this.loading.dismiss();
        let alert = this.alertCtrl.create({
          title:"Correcto",
          subTitle: "Te enviamos a tu correo el enlace para recuperar tu contraseña.",
          buttons: ['Ok']
        });
        alert.present();
      }).catch(error => {
        this.loading.dismiss();
        let alert = this.alertCtrl.create({
          subTitle: error,
          buttons: ['Ok']
        });
        alert.present();
      });
    }
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    this.loading.present();
  }

  isLoggedIn() {
    this.FireAuth.authState.subscribe(res => {
      if (res && res.uid) {
        this.navCtrl.setRoot(HomePage);
      }
    });
  }

  goBack(){
    this.navCtrl.setRoot(LoginPage);
  }

  forgotPassword() {
    this.navCtrl.push(ForgotPasswordPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/forgot-password/forgot-password.ts